import { createFileRoute } from '@tanstack/react-router';
import { OrderStageSettingsPage } from '@/pages/crm/settings/pipelines/order-stages/OrderStageSettingsPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/chain/order-pipeline')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['orders.configurePipeline'], redirectTo: '/dashboard' }),
	component: OrderStageSettingsPage,
});
